import { all, put, takeEvery } from 'redux-saga/effects'
import actions from './actions'

export function* CHANGE_SETTING({ payload: { setting, value } }) {
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      [setting]: value,
    },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.CHANGE_SETTING, CHANGE_SETTING)])
}
